module.exports = __webpack_public_path__ + "static/media/palpatine.3bd0291b.mp3";